import '../ki-icon/ki-icon';
import { html } from 'lit-html';
import { css } from 'lit-element';
import '../ki-popup/ki-popup';
import '../ki-list/ki-list';
import '@giswebgroup/ki-wcp-base/src/components/ki-checkbox/ki-checkbox';
import { repeat } from 'lit-html/directives/repeat';
import localStorage from '../../decorators/localStorage';
import computed from '../../decorators/computed';
import query from '../../decorators/query';

/*
 * col:{
 *   hideAble: Boolean,
 *   hide: Boolean
 * }
 *
 *
 * */

export default function ColumnHider(clz) {
  return class extends clz {
    // language=CSS
    static styles = css`
      .header-cell-hider {
        width: 50px;
        text-align: center;
        cursor: pointer;
        color: gray;
      }
      .header-cell-hider:hover {
        color: #4a4a49;
      }

      .hider.active {
        padding: 2px;
        background-color: var(--theme-color, #0056a0);
        color: white;
        border-radius: 15px;
      }

      ki-popup {
        right: 10px;
        text-align: left;
        bottom: 20px;
        overflow: auto;
        /*temp solution*/
      }
      ki-list {
        min-width: 200px;
      }
      ki-list-item {
        padding: 5px;
        display:flex;
        align-items:center;
      }
      ki-checkbox{
        padding: 10px;
      }
    `;

    constructor() {
      super();
      this.__hiderOptionVisible = false;
    }

    static get properties() {
      return {
        __hiderOptionVisible: {
          type: Boolean,
        },
      };
    }

    @localStorage({
      type: Array,
      initial() {
        return this.columns?.filter(item => item.hideAble && item.hide).map(i => i.field) || [];
      },
    })
    hiddenColumns;

    @computed(['columns', v => v.hiddenColumns?.join(','), '__hiderOptionVisible'])
    get renderingColumns() {
      if (super.renderingColumns.filter(item => item.hideAble).length > 0) {
        return super.renderingColumns
          .filter(col => this.hiddenColumns.indexOf(col.field) < 0)
          .concat([
            {
              field: '__$options',
              renderHeaderCell: () => {
                const togglePopup = () => {
                  this.__hiderOptionVisible = !this.__hiderOptionVisible;
                };

                return html`
                  <div class="cell header-cell-hider">
                    <div class="header-content" @click="${togglePopup}">
                      <ki-icon
                        icon="ki ki-ellipsis-h"
                        class="hider ${this.__hiderOptionVisible ? 'active' : ''}"
                        id="hider"
                      ></ki-icon>
                    </div>
                    <ki-popup
                      for="hider"
                      right="0"
                      top="100%"
                      .visible="${this.__hiderOptionVisible}"
                    >
                      ${this.__renderHiderColumnOptions()}
                    </ki-popup>
                  </div>
                `;
              },
            },
          ]);
      }
      return super.renderingColumns;
    }

    __renderHiderColumnOption(item) {
      return html`
        <ki-list-item>
            <ki-checkbox
              .name="${item.field}"
              .checked="${this.hiddenColumns.indexOf(item.field) < 0}"
              @change="${this._toggleHiderOption}"
            ></ki-checkbox>
            <span class="label">${item.label}</span>
        </ki-list-item>
      `;
    }

    __renderHiderColumnOptions() {
      const options = this.columns.filter(item => item.hideAble);
      const keyFn = op => op.field;
      return html`
        <ki-list>${repeat(options, keyFn, this.__renderHiderColumnOption.bind(this))}</ki-list>
      `;
    }

    @query('ki-checkbox', { all: true })
    __hiderOptionCheckBox;

    _toggleHiderOption() {
      const list = [];
      this.__hiderOptionCheckBox.forEach(c => {
        c.checked || list.push(c.name);
      });
      this.hiddenColumns = list;
    }
  };
}
